// Mirrors the backend's availability statuses (2_server/common/availability.py).
// "reserved" means another customer is paying for it right now, which frees up
// in a few minutes; the others are lasting.
export const AVAILABILITY = {
  AVAILABLE: "available",
  RESERVED: "reserved",
  LOW_STOCK: "low_stock",
  OUT_OF_STOCK: "out_of_stock",
  SOLD: "sold",
  ORDERED: "ordered",
  UNLISTED: "unlisted",
};

export const RESERVED_MESSAGE =
  "Someone is paying for this right now. It may become available again in a few minutes.";

// Why a cart item can't be bought now; empty when it can
export const cartAvailabilityMessage = (item) => {
  switch (item?.availability) {
    case AVAILABILITY.AVAILABLE:
      return "";
    case AVAILABILITY.RESERVED:
      return RESERVED_MESSAGE;
    case AVAILABILITY.LOW_STOCK:
      return `Only ${item.availableQuantity} available. Please lower the quantity.`;
    case AVAILABILITY.OUT_OF_STOCK:
      return "Out of stock";
    case AVAILABILITY.ORDERED:
      return "Already ordered";
    default:
      // sold, unlisted
      return "No longer available";
  }
};
